module.exports = __webpack_public_path__ + "static/img/h5.0f3f666.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hor/h5.jpg
// module id = q1/M
// module chunks = 1